module.exports = __webpack_public_path__ + "static/media/logo-appstore.f0d6b008.png";